import React, { Component } from "react";
import { withRouter, Redirect, Link } from "react-router-dom";
import { Text, View, Image, ScrollView, Platform } from "react-native";
import SignIn from "../../native/screens/sign-in";
import ReactGA from "react-ga";
import { helpers } from "../../native/utils/helpers";
import AuthenticationWrapper from "../../native/components/authentication-wrapper";
import Auth0 from "react-native-auth0";
import { bindActionCreators } from "redux";
import { setUserToken } from "../../redux/User/user.actions";
import { connect } from "react-redux";
import apiHelpers from "../../native/utils/api-helpers";
import Loader from "../../native/components/loader/index.js";

export class SignInScreen extends Component {
  constructor(props) {
    super(props);

    let redirectUrl = null;
    let verifyRedirectUrl = null;
    let allParams = null;
    let webView = helpers.isWeb();

    if (
      webView &&
      process.browser &&
      window.location.search.includes("redirect=")
    ) {
      redirectUrl = this.getRedirectURL(
        window.location.origin,
        window.location.search
      );
      verifyRedirectUrl = redirectUrl;
    } else if (!webView && this.props.route.params) {
      redirectUrl = this.props.route.params.redirect || null;
      verifyRedirectUrl = this.props.route.params.verifyRedirect || null;
      allParams = this.props.route.params;
    }

    this.state = {
      searchQuery: "",
      locationHash: "",
      userIpAddress: "",
      enableBtnLoader: false,
      redirectUrl: redirectUrl,
      verifyRedirectUrl: verifyRedirectUrl,
      allParams: allParams,
    };

    if (process.browser) {
      try {
        ReactGA.pageview(this.props.history.location.pathname);
      } catch (error) {
        console.log("GA tracking error =>", error);
      }
    }
  }

  getLoginHint = (urlString) => {
    let urlParamDict = helpers.getURLParamDict(urlString);
    const providerHint = urlParamDict["providerHint"];
    const emailHint = urlParamDict["emailHint"];

    let loginHint = {};

    if (providerHint) {
      loginHint["provider_hint"] = providerHint;
    }

    if (emailHint) {
      loginHint["email_hint"] = emailHint;
    }
    console.log("loginHint", loginHint);

    return loginHint;
  };

  getRedirectURL = (urlString, urlParamString, encoded = true) => {
    const queryParamArray = urlParamString.split("redirect=");
    const queryParams = queryParamArray[1];
    const isProviderHint = queryParams.includes("providerHint");
    const isEmailHint = queryParams.includes("emailHint");

    let newQuery = queryParams;
    if (isProviderHint && isEmailHint) {
      // Remove both providerHint and emailHint parameters
      newQuery = queryParams
        .replace(/&?providerHint=[^&]*/, "")
        .replace(/&?emailHint=[^&]*/, "");
    } else if (isProviderHint) {
      // Remove only providerHint parameter
      newQuery = queryParams.replace(/&?providerHint=[^&]*/, "");
    } else if (isEmailHint) {
      // Remove only emailHint parameter
      newQuery = queryParams.replace(/&?emailHint=[^&]*/, "");
    }


    let redirectUrl;
    try {
      redirectUrl = decodeURIComponent(newQuery);
    } catch (e) {
      // Handle malformed URI (e.g., lone % characters like "NEWUSER10%")
      redirectUrl = newQuery;
    }
    return redirectUrl;
  };

  getEncodedRedirectURL = (urlParamDict, redirectParamKey = "redirect") => {
    let decodedParamDict = helpers.getDecodedParamDict(urlParamDict);
    let redirectURL = decodedParamDict[redirectParamKey];
    return redirectURL ? redirectURL : "";
  };

  getUnEncodedRedirectURL = (urlParamDict, URLParamString) => {
    let searchArr = URLParamString.replace("?", "").split("&");
    let foundSearch = searchArr.find((searchParam) =>
      searchParam.includes("redirect=")
    );
    let redirectParams = searchArr.find((searchParam) =>
      searchParam.includes("redirect-params=")
    );
    let redirectUrl = "";

    if (foundSearch) {
      let search = foundSearch.replace("redirect=", "");
      redirectUrl = search !== "" ? search : "";
    }

    if (redirectParams) {
      redirectParams = redirectParams.replace("redirect-params=", "");
      redirectUrl = redirectUrl + "?" + redirectParams;
    }

    return redirectUrl;
  };

  getIpAccessInfo = async () => {
    const endpoint = `/verify-ip-access`;
    let body = {};
    try {
      const ipInfo = await apiHelpers.apiRequest(
        endpoint,
        body,
        "POST",
        true,
        false
      );
      if (ipInfo.instituteAccess === true) {
        return {
          institute_access: true,
        };
      }
    } catch (err) {
      console.log("IP error: ", err);
    }
    return false;
  };

  componentDidMount = () => {
    const { login } = this.props.auth;
    let redirectTo;
    try {
      redirectTo = decodeURIComponent(this.state.redirectUrl);
    } catch (e) {
      redirectTo = this.state.redirectUrl;
    }
    let defaultParams = { appState: { returnTo: redirectTo } };
    login({
      ...defaultParams,
      ...this.getLoginHint(window.location.href),
    });
  };

  componentDidUpdate = () => { };

  render() {
    return (
      <View
        style={{
          flexDirection: "row",
          height: "100%",
          alignItems: "center",
          justifyContent: "center",
          position: "absolute",
          width: "100%",
        }}
      >
        <Loader title={"Please wait while we sign you in ..."} />
      </View>
    );
  }
}

const mapStateToProps = (state) => {
  const { app, user } = state;
  return { app, user };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ setUserToken }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthenticationWrapper(SignInScreen));
